module.exports = __webpack_public_path__ + "09812907325c183839c005f0ab41b236.svg";